/* Field: auto ink. Samples the photograph where the type sits and picks light or dark type.
   Manual settings (data-ink="light"/"dark") are left alone. Same-origin images only; otherwise stays light. */
(function () {
  'use strict';
  function lum(img, region) {
    try {
      const c = document.createElement('canvas'), w = 48, h = 48; c.width = w; c.height = h;
      const x = c.getContext('2d', { willReadFrequently: true });
      const iw = img.naturalWidth, ih = img.naturalHeight; if (!iw || !ih) return null;
      // region in image space: the box behind the headline, accounting for object-fit: cover
      const box = img.getBoundingClientRect(), s = Math.max(box.width / iw, box.height / ih);
      const vw = box.width / s, vh = box.height / s, ox = (iw - vw) / 2, oy = (ih - vh) * .45;
      const sx = ox + vw * region.x, sy = oy + vh * region.y, sw = vw * region.w, sh = vh * region.h;
      x.drawImage(img, sx, sy, sw, sh, 0, 0, w, h);
      const d = x.getImageData(0, 0, w, h).data; let t = 0;
      for (let i = 0; i < d.length; i += 4) t += .2126 * d[i] + .7152 * d[i + 1] + .0722 * d[i + 2];
      return t / (d.length / 4) / 255;
    } catch (e) { return null; }
  }
  function apply(plate) {
    if (plate.dataset.ink !== 'auto') return;
    const img = plate.querySelector('img'); if (!img) return;
    const go = () => {
      const region = plate.classList.contains('b') ? { x: 0, y: 0, w: .55, h: .45 } : { x: 0, y: .5, w: .55, h: .5 };
      const l = lum(img, region); if (l == null) return;
      plate.dataset.ink = l > .62 ? 'dark' : 'light';
    };
    if (img.complete && img.naturalWidth) go(); else img.addEventListener('load', go, { once: true });
  }
  document.querySelectorAll('[data-field] .plate').forEach(apply);
})();

/* Scroll-cycled first line: the word advances as the plate travels up the viewport; the last word holds. */
(function () {
  document.querySelectorAll('[data-cycle]').forEach(cyc => {
    const words = [...cyc.querySelectorAll('.w')]; if (words.length < 2) return;
    const plate = cyc.closest('.plate') || cyc; let cur = 0;
    const set = (k) => {
      if (k === cur) return;
      words.forEach((w, j) => { w.classList.toggle('is-on', j === k); w.classList.toggle('is-out', j < k); w.setAttribute('aria-hidden', j === k ? 'false' : 'true'); });
      cur = k;
    };
    const pin = plate.closest('[data-pin]');
    const tick = () => {
      let p;
      if (pin) {
        // pinned: progress through the track while the plate is stuck (0 at pin top hits the viewport top, 1 when it releases)
        const r = pin.getBoundingClientRect(), travel = r.height - plate.offsetHeight;
        p = travel > 0 ? Math.min(1, Math.max(0, -r.top / travel)) : 1;
      } else {
        const r = plate.getBoundingClientRect(), vh = innerHeight;
        p = Math.min(1, Math.max(0, (vh - r.top) / (vh * .66 + r.height * .5)));
      }
      set(Math.min(words.length - 1, Math.floor(p * words.length)));
    };
    addEventListener('scroll', tick, { passive: true }); addEventListener('resize', tick); tick();
  });
})();

/* Technical load-in for a phrase: each text node scrambles through the glyph set and resolves left to right. */
const GL = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#%&/-_<>[]';
function decodeIn(el) {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const nodes = [...el.childNodes].filter(n => n.nodeType === 3 && n.textContent.trim());
  const finals = nodes.map(n => n.textContent); const len = finals.join('').length;
  const dur = Math.min(900, 360 + len * 30), t0 = performance.now();
  el.style.minWidth = el.getBoundingClientRect().width + 'px';
  const tick = now => {
    const p = Math.max(0, Math.min(1, (now - t0) / dur));
    nodes.forEach((n, i) => { const f = finals[i]; const cut = Math.floor(p * f.length); let out = ''; for (let j = 0; j < f.length; j++) { const ch = f[j]; out += (j < cut || ch === ' ' || ch === '.') ? ch : GL[(Math.random() * GL.length) | 0]; } n.textContent = out; });
    if (p < 1) requestAnimationFrame(tick); else { nodes.forEach((n, i) => n.textContent = finals[i]); el.style.minWidth = ''; }
  };
  requestAnimationFrame(tick);
}
/* Accumulating phrases, no lock: the page scrolls normally; phrase k fades in once the plate has travelled far enough
   up the viewport. First is up on arrival; the last is in before the frame is a third of the way out. */
(function () {
  document.querySelectorAll('[data-accumulate]').forEach(plate => {
    const phs = [...plate.querySelectorAll('.phr')]; if (phs.length < 2) return;
    let cur = 0;
    const tick = () => {
      const r = plate.getBoundingClientRect(), vh = innerHeight;
      // 0 when the plate's top enters at the bottom of the viewport; 1 when its top is a third of the way above the viewport top
      const p = Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height * .33)));
      const k = Math.min(phs.length - 1, Math.floor(p * (phs.length + .5)));
      if (k === cur) return; const prev = cur; cur = k;
      phs.forEach((el, j) => el.classList.toggle('is-on', j <= k)); /* fade only (decode tried, felt wrong on the human frame) */
    };
    addEventListener('scroll', tick, { passive: true }); addEventListener('resize', tick); tick();
  });
})();
